import React from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";

import { ACTUAL_FORECAST_PERIOD_ID } from "../constants";
import { type TableRowType } from "../performance-tracking-table";

export const ForecastPeriodFixedRowDataFormatter = ({
  column,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  const row = _row as TableRowType;

  const spend =
    row.data[
      column.name === ACTUAL_FORECAST_PERIOD_ID
        ? "actualSpend"
        : "budgetedSpend"
    ];
  const mix =
    row.data[
      column.name === ACTUAL_FORECAST_PERIOD_ID
        ? "actualSpendMix"
        : "budgetedSpendMix"
    ];

  const textColor =
    column.name === ACTUAL_FORECAST_PERIOD_ID
      ? "text-cosmic"
      : "text-interstellar";

  return (
    <div
      className={`flex justify-end space-x-2 items-center p-2 text-right overflow-hidden ${textColor}`}
    >
      <div>
        <div className="font-medium text-sm font-mono">
          {formatting.formatPercentage(mix, {
            precision: "approximate",
          })}
        </div>
      </div>
    </div>
  );
};
